<script setup>
import {ref} from "vue";

const showAnswer = ref(false);
</script>
<template>
    <div class="w-full p-5 border-t border-b border-dashed border-black cursor-pointer"  @click="showAnswer = !showAnswer">
        <div class="w-full flex justify-between items-center" :class="{'mb-5': showAnswer}">
            <p class="font-sans font-medium text-black text-base lg:text-xl">
                <slot name="question"></slot>
            </p>
            <span>
                <svg :class="{'rotate-180': showAnswer}" width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9852 0.385386C16.4898 0.899234 16.4898 1.73234 15.9852 2.24619L9.09531 9.26374C8.5908 9.77759 7.77283 9.77759 7.26832 9.26374L0.378382 2.24619C-0.126127 1.73234 -0.126127 0.899234 0.378382 0.385386C0.882889 -0.128462 1.70084 -0.128462 2.20535 0.385386L8.18182 6.47252L14.1583 0.385386C14.6628 -0.128462 15.4807 -0.128462 15.9852 0.385386Z" fill="black"/>
                </svg>
            </span>

        </div>
        <div class="gamepass-instruction-accordion" v-if="showAnswer">
            <slot name="answer"></slot>
        </div>
    </div>

</template>
<style lang="css">
.gamepass-instruction-accordion > h2 {
    font-family: "Fira Sans", sans-serif;
    font-size: 20px;
    font-weight: 500;
    color: black;
    padding-inline: 10px;
    margin-bottom: 20px;
}

.gamepass-instruction-accordion > p {
    font-family: "Fira Sans", sans-serif;
    font-size: 18px;
    color: black;
    padding-inline: 10px;
    margin-bottom: 20px;
}

.gamepass-instruction-accordion > strong {
    font-family: "Fira Sans", sans-serif;
    font-size: 18px;
    font-weight: 700;
    color: black;
    padding-inline: 10px;
    margin-bottom: 20px;
}

.gamepass-instruction-accordion > img {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
}
</style>
